export default class User {
  constructor(nombre, apellido, cedula, email, password) {
    this.nombre = nombre;
    this.apellido = apellido;
    this.cedula = cedula;
    this.email = email;
    this.password = password;
  }
}


